import React from "react";
import PropTypes from "prop-types";
import { CardContainer } from "./style";

const Card = ({ children, ...restProps }) => {
	return <CardContainer {...restProps}>{children}</CardContainer>;
};

Card.defaultProps = {
	bgColor: "var(--primary-neutral-white)",
};

Card.propTypes = {
	bgColor: PropTypes.string,
};

export default Card;
